import { PontoDiario } from '@/service/api'

export type NivelPontoDiario = 'centroCusto' | 'local' | 'funcionario' | 'dia'

export const ORDEM_NIVEIS: NivelPontoDiario[] = [
    'centroCusto',
    'local',
    'funcionario',
    'dia',
]

export const LABEL_NIVEL: Record<NivelPontoDiario, string> = {
    centroCusto: 'Centro de custo',
    local: 'Local',
    funcionario: 'Funcionário',
    dia: 'Dia',
}

// Mesmo shape granular devolvido pelo GET /relatorio-ponto-diario — reaproveita
// o tipo do endpoint em vez de redefinir os mesmos campos aqui.
export type LinhaGranularPontoDiario = PontoDiario
